// extracted by mini-css-extract-plugin
export default {"wrapper":"BarChartCustomTooltip_wrapper__81PYJ"};